import {
  componentsTranslations,
  ComponentsTranslations,
} from './comnponents/components.translations.pl.ts';
import { utilsTranslations, UtilsTranslations } from './util/utils.translations.pl.ts';
import { viewsTranslations, ViewsTranslations } from './views/views.translations.pl';
import { SkillTypeDto } from '@/api/generated';

export const NAMESPACE = 'letsorange';

export interface AppTranslations {
  [NAMESPACE: string]: {
    components: ComponentsTranslations;
    consents: {
      additionalPersonalDataProcessingConsentOrange: string;
      collapse: string;
      dataProcessingInfoHtml: string;
      dataProcessingInfoTitle: string;
      expand: string;
      futureRecruitmentDataProcessingConsentOrange: string;
      requiredConsent: string;
      warningNoConsent: string;
    };
    quizFinishedPage: {
      messages: {
        [key: string]: {
          message: string;
          subMessage: string;
        };
      };
    };
    quizInitializedPage: {
      buttons: {
        next: string;
      };
      errorMessage: string;
      heading: string;
      unsupportedType: string;
    };
    skillsAssessmentCollectedPage: {
      buttons: {
        finish: string;
      };
      heading: string;
      subMessage1: string;
      subMessage2: string;
      subMessage3: string;
      subMessage4: string;
      subMessage5: string;
      subMessage6: string;
      here: string;
      skillTypes: Record<SkillTypeDto, string>;
      competence: string;
      introText: string;
      languageIntroText: string;
      standardRatingLabels: Record<'noKnowledge' | 'basic' | 'good' | 'advanced', string>;
      standardRatingDescriptions: Record<'noKnowledge' | 'basic' | 'good' | 'advanced', string>;
      standardRatingShortLabels: Record<'noKnowledge' | 'basic' | 'good' | 'advanced', string>;
      languageRatingLabels: Record<'a1a2' | 'b1b2' | 'c1c2' | 'native', string>;
    };
    startGamePage: {
      buttons: {
        startGame: string;
      };
      heading: string;
      list: {
        listItem1: string;
        listItem2: string;
        listItem3: string;
        listItem4: string;
        listItem5: string;
        listItem6: string;
        listItem7: string;
        listItem8: string;
      };
    };
    utils: UtilsTranslations;
    views: ViewsTranslations;
    welcomeAgainPage: {
      buttons: {
        continue: string;
      };
      heading: string;
      subMessage: string;
    };
    welcomePage: {
      buttons: {
        submit: string;
      };
      checkboxText: string;
      description: string;
      emailPlaceholder: string;
      passwordPlaceholder: string;
      emailPrompt: string;
      error: {
        wentWrong: string;
      };
      heading1: string;
      heading2: string;
      popup: {
        message: string;
        subMessage: string;
        emailNotReceived1: string;
        emailNotReceived2: string;
        emailNotReceivedHere: string;
        resendEmailSent: string;
      };
      subheading1: string;
      subheading2: string;
    };
  };
}

export const plTranslation: AppTranslations = {
  [NAMESPACE]: {
    components: componentsTranslations,
    consents: {
      additionalPersonalDataProcessingConsentOrange:
        'Wyrażam zgodę na przetwarzanie moich danych, które dobrowolnie podałem/podałam, przez Orange Polska S.A. z siedzibą w Warszawie. Zgadzam się, aby Orange Polska S.A. (z siedzibą w Warszawie) mogło przetwarzać dane osobowe, które nie są wymagane prawnie, ale które dobrowolnie przekazałem/przekazałam w mojej aplikacji na potrzeby procesu rekrutacji wskazanego przeze mnie dla Orange Polska S.A.',
      collapse: 'zwiń',
      dataProcessingInfoHtml: `<p>Złożenie przez Ciebie aplikacji oznacza Twoją zgodę na przetwarzanie podanych przez Ciebie danych osobowych w niniejszym procesie rekrutacyjnym, w tym przesłania do Ciebie prośby o wyrażenie anonimowej, dobrowolnej opinii o jakości realizowanej rekrutacji.</p><br/><p>Administratorem Twoich danych osobowych jest Orange Polska S.A. z siedzibą w Warszawie, pod adresem Aleje Jerozolimskie 160, 02-326 Warszawa (dalej Orange Polska). Dane kontaktowe inspektora ochrony danych w Orange Polska: inspektorochronydanych@orange.com</p><br/><p>W procesie rekrutacji przetwarzać będziemy dane wymagane przepisami prawa oraz inne dane, uzyskane w trakcie spotkań rekrutacyjnych, w tym z test&oacute;w, w kt&oacute;rych uczestniczyłaś/eś i innych zastosowanych w trakcie spotkań rekrutacyjnych metod weryfikacji kompetencji i umiejętności, uzyskanych za Twoją zgodą. Dane te będą służyły do ustalenia Twoich kompetencji i umiejętności i ich oceny pod kątem spełnienia wymagań na stanowisko, o kt&oacute;re się ubiegasz.</p><br/><p>Twoje dane przetwarzane będą w celu przeprowadzenia procesu rekrutacji, na podstawie przepis&oacute;w prawa (obowiązek prawny administratora danych), a dla danych, kt&oacute;rych przetwarzanie nie wynika z przepis&oacute;w prawa oraz w celu przesłania do Ciebie prośby o wyrażenie anonimowej, dobrowolnej opinii o jakości realizowanej rekrutacji - na podstawie Twojej zgody:</p><br/><p>&ndash; przez okres 12 miesięcy licząc od daty złożenia aplikacji,</p><br/><p>&ndash; przez okres 24 miesięcy od daty złożenia aplikacji, jeśli wyraziłeś/łaś zgodę na przetwarzanie Twoich danych w przyszłych rekrutacjach.</p><br/><p>Podanie danych obejmujących imię i nazwisko, datę urodzenia, adres do korespondencji, adres poczty elektronicznej albo numer telefonu, wykształcenie, kwalifikacje zawodowe i przebieg dotychczasowego zatrudnienia wynika z przepis&oacute;w prawa. Podanie innych danych jest dobrowolne.</p><br/><p>Twoje dane osobowe mogą być przekazywane:</p><br/><p>a) podmiotom przetwarzającym, kt&oacute;re wsp&oacute;łpracują z Orange Polska w prowadzeniu rekrutacji lub świadczącym pomoc prawną,</p><br/><p>b) podmiotom obsługującym na nasze zlecenie systemy teleinformatyczne lub udostępniającym nam narzędzia teleinformatyczne oraz ich podwykonawcom.</p><br/><p>Masz prawo do:</p><br/><p>- cofnięcia zgody w dowolnym momencie; przy czym cofnięcie zgody nie będzie miało wpływu na zgodność z prawem przetwarzania danych na podstawie zgody w okresie przed jej cofnięciem,</p><br/><p>- żądania dostępu do swoich danych przetwarzanych przez Orange Polska,</p><br/><p>- sprostowania (poprawiania) danych,</p><br/><p>- usunięcia lub ograniczenia ich przetwarzania,</p><br/><p>- przeniesienia danych, co oznacza prawo do otrzymania danych przetwarzanych przez Orange Polska lub żądanie ich przeniesienia do innego podmiotu,</p><br/><p>- wniesienia sprzeciwu wobec przetwarzania danych.</p><br/><p>Zakres każdego z tych praw oraz sytuacje, w kt&oacute;rych można z nich skorzystać, wynikają z przepis&oacute;w prawa. To, z kt&oacute;rego uprawnienia możesz skorzystać, zależeć będzie np. od podstawy prawnej oraz celu przetwarzania danych. W celu skorzystania z wyżej wymienionych praw możesz przesłać wniosek listownie na adres: Orange Polska S.A., Al. Jerozolimskie 160, 02-326 Warszawa lub na adres e-mail rekrutacja@orange.com. Jeśli będzie</p><br/><p>to konieczne, możemy poprosić Cię o podanie dodatkowych informacji pozwalających na uwierzytelnienie w celu sprawdzenia, czy masz prawo do złożenia wniosku.&rdquo;</p><br/><p>Jeśli uznasz, że Twoje dane osobowe przetwarzane są niezgodnie z prawem możesz wnieść skargę do Prezesa Urzędu Ochrony Danych Osobowych.</p><br/><p>Dodatkowo złożenie przez Ciebie aplikacji oznacza że zapoznałeś/łaś się z Wewnętrzną wsp&oacute;lną procedurą dokonywania zgłoszeń naruszeń prawa i podejmowania działań następczych w podmiotach Grupy Kapitałowej Orange Polska zwaną dalej &quot;Procedurą Zgłoszeń Wewnętrznych&rdquo;.</p><br/><p>Procedura Zgłoszeń Wewnętrznych jest dostępna pod linkiem:</p><br/><p>https://www.orange.pl/etyka-i-compliance</p>
`,
      dataProcessingInfoTitle:
        'Informacja o przetwarzaniu danych osobowych w Orange Polska S.A. z siedzibą w Warszawie',
      expand: 'rozwiń',
      futureRecruitmentDataProcessingConsentOrange:
        'Wyrażam zgodę na przetwarzanie moich danych osobowych zawartych w przekazanych dokumentach przez Orange Polska S.A. z siedzibą w Warszawie w celu uczestnictwa w przyszłych procesach rekrutacyjnych prowadzonych w Orange Polska S.A. ',
      requiredConsent: 'obowiązkowa zgoda',
      warningNoConsent:
        'Jeśli nie zaznaczysz powyższej zgody nie będziemy mogli się z Tobą skontaktować',
    },
    quizFinishedPage: {
      messages: {
        '0': {
          message: 'To już prawie wszystko',
          subMessage:
            'Twoja aplikacja jest już prawie gotowa. Obszary biznesowe, które Cię interesują to: <span class="text-primary font-bold">{{ areas }}</span>',
        },
        '1': {
          message: 'To jeszcze nie koniec',
          subMessage:
            'Za chwilę poproszę Cię jeszcze o określenie Twojego poziomu wiedzy, przy kompetencjach, które są dla nas kluczowe w wybranych przez Ciebie obszarach.',
        },
      },
    },
    quizInitializedPage: {
      buttons: {
        next: 'Dalej',
      },
      errorMessage: 'Failed to load the quiz question.',
      heading: 'Welcome to the Quiz App',
      unsupportedType: 'Unsupported question type',
    },
    skillsAssessmentCollectedPage: {
      buttons: {
        finish: 'Zakończ!',
      },
      heading: 'Dziękuję za wspólną przygodę',
      subMessage1: 'Twoje zgłoszenie zostało właśnie wysłane. ',
      subMessage2:
        'Informację zwrotną otrzymasz od nas w ciągu 3 dni roboczych. Pełny opis procesu rekrutacji znajdziesz ',
      subMessage3: 'Potwierdzenie przyjęcia aplikacji',
      subMessage4: 'wysłaliśmy do Ciebie mailem. ',
      subMessage5: 'Jeśli wiadomość nie dotarła, skontaktuj się z nami: {{ contactEmail }} ',
      subMessage6: 'Do zobaczenia!',
      here: 'tutaj',
      competence: 'Kompetencja',
      skillTypes: {
        [SkillTypeDto.ProgrammingLanguage]: 'Języki programowania',
        [SkillTypeDto.Tool]: 'Narzędzia',
        [SkillTypeDto.SystemTechnologyMethodology]: 'Systemy, technologie, metodologie pracy',
        [SkillTypeDto.Language]: 'Języki',
      },
      introText:
        'Wybierz kompetencje, które uważasz, że są Twoją mocną stroną. Na tej podstawie będziemy mogli dopasować odpowiednią praktykę do Twoich możliwości i potencjału.',
      languageIntroText: 'Na koniec określ jeszcze swój poziom znajomości języków:',
      standardRatingLabels: {
        noKnowledge: 'Nie posiadam wiedzy',
        basic: 'Podstawowy',
        good: 'Dobry',
        advanced: 'Zaawansowany',
      },
      standardRatingDescriptions: {
        noKnowledge: 'Nie posiadam wiedzy w tym zakresie',
        basic:
          'Posiadam podstawową wiedzę, często teoretyczną, w zadaniach praktycznych potrzebuję wsparcia',
        good: 'Posiadam wiedzę i potrafię efektywnie wykorzystywać ją w standardowych zadaniach, w bardziej złożonych potrzebuję wsparcia',
        advanced:
          'Potrafię sprawnie i samodzielnie korzystać z technologii w większości sytuacji nawet trudnych',
      },
      standardRatingShortLabels: {
        noKnowledge: 'Brak',
        basic: 'Podst.',
        good: 'Dobry',
        advanced: 'Zaaw.',
      },
      languageRatingLabels: {
        a1a2: 'A1/A2',
        b1b2: 'B1/B2',
        c1c2: 'C1/C2',
        native: 'Ojczysty',
      },
    },
    startGamePage: {
      buttons: {
        startGame: 'Rozpocznij grę',
      },
      heading: 'Co warto wiedzieć przed rozpoczęciem gry rekrutacyjnej:',
      list: {
        listItem1:
          'na przejście gry masz {{ timeToCompleteInMinutes }} minut, co pozwoli Ci zagłębić się w świat Orange i swobodnie rozwiązać zadania',
        listItem2: 'zadania w grze mają podobny poziom trudności',
        listItem3: 'znajdź spokojne miejsce, gdzie nic nie będzie Cię rozpraszać',
        listItem4: 'upewnij się, że masz dobre połączenie z internetem',
        listItem5:
          'w grze jest ścieżka dźwiękowa, więc jeśli chcesz jej posłuchać przygotuj słuchawki',
        listItem6: 'po przejściu gry otrzymasz informację zwrotną',
        listItem7: 'masz możliwość przejścia przez grę tylko raz',
        listItem8:
          'jeśli przerwiesz grę z przyczyn technicznych (np. brak internetu), możesz do niej wrócić, jednak tylko raz i do miejsca, w którym została przerwana',
      },
    },
    utils: utilsTranslations,
    views: viewsTranslations,
    welcomeAgainPage: {
      buttons: {
        continue: 'Kontynuuj',
      },
      heading: 'Dobrze, że znów tu jesteś.',
      subMessage:
        'Już myślałem, że straciłem z Tobą kontakt. Nie traćmy czasu. Możesz kontynuować grę rekrutacyjną.',
    },
    welcomePage: {
      buttons: {
        submit: 'Zaczynamy!',
      },
      checkboxText:
        "Wyrażam zgodę na przetwarzanie moich danych osobowych (podanego adresu e-mail) w celu otrzymywania komunikacji mailowej dedykowanej rekrutacji na praktyki Let's Orange.",
      description:
        'Zdobywaj doświadczenie i rozwijaj się w Orange przy projektach, które mają znaczenie. Czas rozegrać to po swojemu i odkryć własne talenty.',
      emailPlaceholder: 'Podaj swój adres e-mail',
      passwordPlaceholder: 'Hasło',
      emailPrompt: 'Na początek zweryfikuj swój e-mail.',
      error: {
        wentWrong: 'Coś poszło nie tak',
      },
      heading1: 'Przyszłość',
      heading2: 'tu jest',
      popup: {
        message: 'Na podany e-mail wysłaliśmy link weryfikacyjny',
        subMessage:
          'Kliknij w link w otrzymanej wiadomości i przejdź do kolejnych kroków rekrutacji.',
        emailNotReceived1: 'E-mail nie dotarł? Sprawdź folder spam lub kliknij ',
        emailNotReceived2: ', aby go ponownie wysłać.',
        emailNotReceivedHere: 'tu',
        resendEmailSent: ' Poszło!',
      },
      subheading1: "Aplikuj bez CV na praktyki Let's Orange.",
      subheading2: 'Wejdź do gry rekrutacyjnej i rozegraj to po swojemu.',
    },
  },
};
